export default __webpack_public_path__ + "static/3-business-freedom-48dcb06a41a76e9fb15361f26d612b05.jpg";